import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../api";
import "./LoginView.css";

const ResetPasswordView: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [newPwd, setNewPwd]         = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [msg, setMsg]   = useState<{ type: "error" | "success"; text: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) setMsg({ type: "error", text: "Invalid or missing reset link." });
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg(null);
    if (newPwd !== confirmPwd) { setMsg({ type: "error", text: "Passwords do not match." }); return; }
    if (newPwd.length < 6)     { setMsg({ type: "error", text: "Password must be at least 6 characters." }); return; }

    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPwd });
      setMsg({ type: "success", text: "Password updated. Redirecting to login…" });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err: any) {
      setMsg({ type: "error", text: err.response?.data?.message || "Failed to reset password." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-view-container">
      <h2 className="login-title">Reset Password</h2>

      {!token ? (
        <p className="error-message">Invalid or missing reset link.</p>
      ) : done ? (
        msg && <p className="success-message">{msg.text}</p>
      ) : (
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <div className="form-group">
            <label className="form-label">New Password:</label>
            <input
              type="password"
              className="modern-input-field"
              placeholder="Min. 6 characters"
              value={newPwd}
              onChange={e => setNewPwd(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New Password:</label>
            <input
              type="password"
              className="modern-input-field"
              value={confirmPwd}
              onChange={e => setConfirmPwd(e.target.value)}
              disabled={loading}
            />
          </div>
          {msg && (
            <p className={msg.type === "error" ? "error-message" : "success-message"}>
              {msg.text}
            </p>
          )}
          <button type="submit" className="submit-button" disabled={loading || !token}>
            {loading ? "Updating…" : "Set New Password"}
          </button>
        </form>
      )}

      <div className="set-pwd-toggle" style={{ marginTop: "16px" }}>
        <button type="button" className="set-pwd-link" onClick={() => navigate("/login")}>
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ResetPasswordView;
